import type { BaseProperties, EventContextProperties } from "../types";

const convertToStringRecord = (
	obj: Record<string, unknown>,
): Record<string, string> => {
	const result: Record<string, string> = {};

	for (const [key, value] of Object.entries(obj)) {
		if (value != null) {
			result[key] = value.toString();
		} else {
			result[key] = "";
		}
	}

	return result;
};

export const prepareProperties = (
	baseProperties: BaseProperties,
	contextProperties?: EventContextProperties,
	properties?: Record<string, string>,
): Record<string, string> => {
	const preparedProperties = {
		...baseProperties,
		...(contextProperties || {}),
		...(properties || {}),
	};

	return convertToStringRecord(preparedProperties);
};
